import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Common } from '../../services/common';
import { MemberLedger } from '../../services/member-ledger';
import { Loaders } from '../../services/loaders';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-payment',
  imports: [CommonModule],
  templateUrl: './payment.html',
  styleUrl: './payment.scss',
})
export class Payment {
 transactionAmount: any = 0;
  amount: any;
  paymentLink: any;

  isLoading: boolean = false;

  constructor(private route: ActivatedRoute,
    private memberLedger: MemberLedger,
    private cd: ChangeDetectorRef,
    private loader: Loaders,
    private commonService: Common
  ) { }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      const isDecrypted = params['decrypted'] === 'true';
      this.paymentLink = params['link']
        ?.replace(/ /g, '+')
        ?.replace(/"/g, '');

      this.amount = params['amount']
        ?.replace(/ /g, '+');
        
      if (isDecrypted) {
        this.transactionAmount = this.amount;
        this.isLoading = false;
        this.cd.detectChanges();
        return;
      }

      if (this.amount && this.paymentLink) {
        this.callDecryptApi();
      }
    });
  }

  redirectLink() {
    if (!this.paymentLink) {
      this.commonService.showWarning('Payment link is currently unavailable.');
      return;
    }
    window.location.href = this.paymentLink;
  }

  callDecryptApi() {
    this.isLoading = true;
    const startTime = Date.now();
    this.memberLedger.decryptPayment(this.amount, this.paymentLink).subscribe({
      next: (res: any) => {
        const elapsed = Date.now() - startTime;
        const delay = Math.max(800 - elapsed, 0);

        setTimeout(() => {
          this.isLoading = false;

          if (res.status == 200 && res.body?.entityResponse) {
            this.transactionAmount = res.body.entityResponse?.amount;
            this.paymentLink = res.body.entityResponse?.paymentLink;
            if (!this.paymentLink) {
              this.commonService.showWarning('Payment link is currently unavailable.');
            }
          }

          this.cd.detectChanges();
        }, delay);
      },

      error: (err) => {
        const elapsed = Date.now() - startTime;
        const delay = Math.max(1000 - elapsed, 0);

        setTimeout(() => {
          this.isLoading = false;
          this.commonService.handleApiError(err);
        }, delay);
      }
    });
  }
}
